import { axiosInstance } from "../../../utils/axios_config"

export default function IntegrationCustomerService() {

    this.getCustomers = async () => {
        return axiosInstance.post('Customer');
    }
}